import QiimayaalDahab from "./QiimayaalDahab"
import Qoraal_Qiime from "./QoraalQiime"
function Qiimayaal (){
    return(
        <>
    {/* <!--------------------------qiimayaasha dahabka---------------> */}
    <section className="qiimayaasha dahabka">
        <div className="haye">
            <div className="laba_qay_qii">
                {/* qoraalo */}
                <Qoraal_Qiime />
                {/* qiimayaa */}
                <QiimayaalDahab />
            </div>

        </div>
    </section>
        </>
    )
}


export default Qiimayaal